import routes from "./CheckListRoutes";
import store from "./CheckListStore";

export default {
  install(Vue, options) {
    options.router.addRoute(...routes);
    options.store.registerModule("Checklist", store);
  },
};
